import {Box} from '@primer/styled-react'

import styles from './LanguageCircle.module.css'

export function LanguageCircle({color}: {color?: string}) {
  return (
    <Box
      sx={{
        bg: color || 'attention.emphasis',
      }}
      className={styles.LanguageCircleIndicator}
    />
  )
}

try{ LanguageCircle.displayName ||= 'LanguageCircle' } catch {}